import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = {
  "data-testid": "dex-reconcile-scan-rekon-results-filter",
  class: "flex items-center gap-4 w-full"
}
const _hoisted_2 = { class: "flex-1 min-w-0" }
const _hoisted_3 = { class: "w-1/2 min-w-0 flex items-center gap-x-4" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Search = _resolveComponent("Search")!
  const _component_CustomDropdown = _resolveComponent("CustomDropdown")!

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode("div", _hoisted_2, [
      _createVNode(_component_Search, {
        class: "w-full",
        "data-testid": "dex-reconcile-scan-rekon-results-filter-search",
        placeholder: _ctx.$t('handoverV2.update.filter.search'),
        value: _ctx.modelValue.keyword,
        isIconLeft: true,
        isIconClearRight: true,
        minChar: 0,
        timeout: 300,
        onInput: _ctx.onSearchInput,
        onClear: _ctx.onSearchClear,
        customMargin: ''
      }, null, 8, ["placeholder", "value", "onInput", "onClear"])
    ]),
    _createVNode("div", _hoisted_3, [
      _createVNode(_component_CustomDropdown, {
        class: "w-full",
        placeholder: _ctx.$t('handoverV2.update.common.product'),
        options: _ctx.productOptions,
        onSelect: _ctx.onSelectProduct,
        selectedItem: _ctx.modelValue.product,
        isDisabled: false,
        disableBackground: false
      }, null, 8, ["placeholder", "options", "onSelect", "selectedItem"]),
      _createVNode(_component_CustomDropdown, {
        class: "w-full",
        placeholder: _ctx.$t('handoverV2.update.common.commodity'),
        options: _ctx.commodityOptions,
        onSelect: _ctx.onSelectCommodity,
        selectedItem: _ctx.modelValue.commodity,
        isDisabled: false,
        disableBackground: false
      }, null, 8, ["placeholder", "options", "onSelect", "selectedItem"])
    ])
  ]))
}